export enum ConnectionPermissionType {
    SCHEDULE = 'sched',
    LOCATION = 'loc',
    COMPANY = 'company'
}
